// node modules
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import MuiTabs from '@material-ui/core/Tabs';
import MuiTab from '@material-ui/core/Tab';

// app modules: services
import history from 'services/history';

// assets
import CssTabs from './Tabs.scss';

function Tabs(props) {
  const { options, onSelect, className, tabClassName, selected, ariaLabel, idPrefix } = props;
  useStyles(CssTabs);
  const handleChange = (event, newValue) => {
    const selectedOption = options.find(option => option.id === newValue);
    if (selectedOption?.href) {
      history.push(selectedOption?.href);
    } else if (selectedOption && typeof onSelect === 'function') {
      onSelect(selectedOption);
    }
  };
  return (
    <div className={classNames(className, 'tabs')}>
      <MuiTabs
        value={selected}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label={ariaLabel}
        TabIndicatorProps={{ className: 'tabs__indicator' }}
        TabScrollButtonProps={{ className: 'tabs__scroll-button' }}
        className="tabs__tabs"
      >
        {options.map((option, index) => (
          <MuiTab
            key={option.id}
            id={`${idPrefix}-tab-${index}`}
            aria-controls={`${idPrefix}-tabpanel-${index}`}
            label={option.label}
            value={option.id}
            className={classNames(tabClassName, 'tabs__tab')}
            component="a"
            href={option.href}
            onClick={event => {
              event.preventDefault();
            }}
          />
        ))}
      </MuiTabs>
    </div>
  );
}

Tabs.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  idPrefix: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ).isRequired,
  onSelect: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tabClassName: PropTypes.string,
};

Tabs.defaultProps = {
  ariaLabel: 'Tabs',
  className: null,
  idPrefix: 'default',
  onSelect: () => {},
  tabClassName: null,
};

export default Tabs;
